import { IconButton } from '@fullscreendigital/carrefour-dex-fe'
import { Box } from '@mui/material'
import s from './LargeIconButton.modules.scss'

export interface LargeIconButtonProps {
  label: string
  startIcon: React.ReactNode
  onClick: () => void
}

const LargeIconButton = (props: LargeIconButtonProps) => {
  const { label, startIcon, onClick } = props

  return (
    <Box className={s.btnContainer}>
      <IconButton
        startIcon={startIcon}
        variant="outlined"
        size="large"
        label={label}
        onClick={onClick}
      />
    </Box>
  )
}

export default LargeIconButton
